import {
  Button, Card, IncidentForm, IncidentHistory, Notice, Permissions, Stack, useI18n, usePermission,
} from '@daghfal/core';
import { useState } from 'react';

/**
 * A child's incidents on their page, each opening its record, and recording a new one (FR-CHD-11, FR-CHD-14).
 *
 * Shown to holders of `health.view`; recording needs `incident.create`. The family is told by the API the moment an
 * incident is saved (FR-CHD-12).
 */
export function IncidentsCard({ childId }: { childId: number }) {
  const { t } = useI18n();
  const canView = usePermission(Permissions.health.view);
  const canRecord = usePermission(Permissions.health.createIncident);
  const [recording, setRecording] = useState(false);
  const [recorded, setRecorded] = useState(false);

  if (!canView) return null;

  return (
    <Card
      title={t('incidents.history')}
      action={!recording && canRecord && (
        <Button variant="secondary" onClick={() => { setRecording(true); setRecorded(false); }}>{t('incidents.new')}</Button>
      )}
    >
      <Stack>
        {recorded && <Notice tone="success">{t('incidents.recorded')}</Notice>}
        {recording && (
          <IncidentForm
            childId={childId}
            onRecorded={() => { setRecording(false); setRecorded(true); }}
            onCancel={() => setRecording(false)}
          />
        )}
        <IncidentHistory childId={childId} link={(incident) => `/incidents/${incident.id}`} />
      </Stack>
    </Card>
  );
}
